import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import * as crypto from 'crypto-js';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { NIRegistration } from '../interface/networkinternational/networkinternational-registration.interface';
import { PaymentRegistrationResponse } from '../interface/payvision/payment-registration-reponse.interface';

/**
 * @description this service help comunicate with payment service
 * when provider is Network International
 * @export
 * @class NIService
 */
@Injectable()
export class NIService {

    constructor(private _http: Http) { }

    /**
     * @description to get the Network International checkout registration form
     * @param {number} storeId
     * @param {paymentRegistrationRequest} NIRegistration
     * @returns {Observable<any>}
     * @memberof NIService
     */
    getNIForm(storeId: number, paymentRegistrationRequest: NIRegistration)
        : Observable<PaymentRegistrationResponse> {
        const headers = this.getPaymentHeaders();
        return this._http
            .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'payments/store/' + storeId +
            '/payment-checkout-form ')), paymentRegistrationRequest, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this is used to get payment headers
     * @returns {Headers}
     * @memberof NIService
     */
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }

    /**
     * @description this method is used to get payment crypto hashed value
     * @returns {string}
     * @memberof NIService
     */
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }

    /**
    * To handle the obervable error response
    * @param  {Response|any} error
    */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/networkinternational.service.ts